import { IComponentOptions } from 'angular';
import nvSdcModule from '../../nv.sdcModule.module';

export const FilterStatusComponent: IComponentOptions = {
  template:
    '<span class="md-body-1" ng-bind="numDisplayedStudents"></span>' +
    '<span class="md-body-1"> of</span> ' +
    '<span class="md-body-1" ng-bind="numTotalStudents"></span>' +
    '<span class="md-body-1"> students displayed</span>',
  controller($scope, SDCStore) {
    $scope.$listenTo(SDCStore, ['filter'], updateDisplay);
    $scope.$listenTo(SDCStore, ['recentEditedStudentIds'], updateDisplay);

    function updateDisplay() {
      $scope.numDisplayedStudents = SDCStore.getFilteredStudents(null, true).length;
      $scope.numTotalStudents = SDCStore.getAllStudents().length;
    }
  },
};

angular.module(nvSdcModule).component('filterStatus', FilterStatusComponent);
